// Bridges Next's official router-transition hook (instrumentation-client.ts's
// onRouterTransitionStart) to the global navigation progress bar. The hook runs
// at module scope, the bar is a React component — a window event is the clean
// seam between them.
export const NAVIGATION_START_EVENT = 'app:navigation-start';
